import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import ErrorBoundary from './toolympus/components/app/ErrorBoundary';
import AppRouter from './AppRouter';

import { Providers } from './Providers';
import { LoginContainer, SignupContainer, ResetPasswordContainer, RestorePasswordContainer } from './components/Auth';
import { LoginOTP } from './components/Auth/LoginOTP';

const App: React.FC = () => {
    return (
        <Providers>
            <Router>
                <ErrorBoundary>
                    <Switch>
                        <Route path='/signup' component={SignupContainer} />
                        <Route path='/login' component={LoginContainer} />
                        <Route path='/login-otp' component={LoginOTP} />
                        <Route path='/reset' component={ResetPasswordContainer} />
                        <Route path='/restore-password' component={RestorePasswordContainer} />
                        <Route path='/' component={AppRouter} />
                    </Switch>
                </ErrorBoundary>
            </Router>
        </Providers>
    );
}

export default App;